'use strict';

module.exports = function toVisualizerMolfile() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var diastereotopic = options.diastereotopic;

  var highlight = [];
  var atoms = {};
  if (diastereotopic) {
    var heavyAtomHydrogen = options.heavyAtomHydrogen;
    var hydrogenInfo = {};
    this.getExtendedDiastereotopicAtomIDs().forEach(function (line) {
      hydrogenInfo[line.oclID] = line;
    });

    var diaIDs = this.getGroupedDiastereotopicAtomIDs();
    diaIDs.forEach(function (diaID) {
      atoms[diaID.oclID] = diaID.atoms;
      highlight.push(diaID.oclID);
      if (heavyAtomHydrogen) {
        if (hydrogenInfo[diaID.oclID] && hydrogenInfo[diaID.oclID].nbHydrogens > 0) {
          hydrogenInfo[diaID.oclID].hydrogenOCLIDs.forEach(function (id) {
            highlight.push(id);
            atoms[id] = diaID.atoms;
          });
        }
      }
    });
  } else {
    var size = this.getAllAtoms();
    highlight = new Array(size).fill(0).map(function (a, index) {
      return index;
    });
    atoms = highlight.map(function (a) {
      return [a];
    });
  }

  var molfile = {
    type: 'mol2d',
    value: this.toMolfile(),
    _highlight: highlight,
    _atoms: atoms
  };

  return molfile;
};


// WEBPACK FOOTER //
// ./lib/extend/toVisualizerMolfile.js